import { Fragment, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./Header.css";
import DesktopDropdown from "../DesktopDropdown/DesktopDropdown";
import logo from "../../assets/images/logo.png";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MobileDropdown from "../MobileDropdown/MobileDropdown";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const location = useLocation();
  const isServiceActive = location.pathname.startsWith("/service");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleOpen = () => setMenuOpen(true);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setIsClosing(false);
    }, 500); // same as animation duration
  };

  return (
    <Fragment>
      <section className={`custom-navbar ${scrolled ? "scrolled" : ""}`}>
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* LOGO */}
            <NavLink to="/" end className="navbar-brand">
              <img
                src={logo}
                loading="lazy"
                className="logo-img"
                alt="img not found"
              />
              <span className="text-uppercase text-white">
                Kairaa Techserve
              </span>
            </NavLink>

            {/* MOBILE HAMBURGER – CUSTOM */}
            <label className="burger d-lg-none" htmlFor="burger">
              <input
                type="checkbox"
                id="burger"
                checked={menuOpen && !isClosing}
                onChange={() => {
                  if (menuOpen) {
                    handleClose(); // CLOSE with animation
                  } else {
                    handleOpen(); // OPEN with animation
                  }
                }}
              />
              <span></span>
              <span></span>
              <span></span>
            </label>

            {/* DESKTOP NAVBAR */}
            <div className="collapse navbar-collapse d-none d-lg-flex">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink to="/" end>
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/about" end>
                    About Us
                  </NavLink>
                </li>
                <li className="nav-item mega-menu">
                  <button
                    type="button"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Services
                  </button>
                  <div className="dropdown-menu">
                    <div className="desktop-menu">
                      <DesktopDropdown />
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <button
                    type="button"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Portfolio
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="">
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="">
                        Events
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="">
                        Projects
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <NavLink to="/" end>
                    Blog
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/contact" end>
                    Contact
                  </NavLink>
                </li>
                <li className="career-btn">
                  <NavLink to="/" end>
                    <span>Career</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </section>

      {/* CUSTOM MOBILE MENU (AOS + GLASS + SLIDE) */}
      {menuOpen && (
        <>
          {/* Overlay */}
          <div className="mobile-overlay" onClick={handleClose} />

          {/* Panel */}
          <div className={`mobile-menu-panel ${isClosing ? "closing" : ""}`}>
            <ul className="navbar-nav flex-column mobile-nav-links">
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={handleClose}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={handleClose}
                >
                  About Us
                </NavLink>
              </li>
              <li
                className={`nav-item mega-menu ${
                  isServiceActive ? "active" : ""
                }`}
              >
                <button
                  type="button"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Services
                </button>
                <div className="dropdown-menu">
                  <div className="mobile-menu">
                    <MobileDropdown handleClose={handleClose} />
                  </div>
                </div>
              </li>
              <li className="nav-item dropdown">
                <button
                  type="button"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Portfolio
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/"
                      onClick={handleClose}
                    >
                      Gallery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/"
                      onClick={handleClose}
                    >
                      Events
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/"
                      onClick={handleClose}
                    >
                      Projects
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink
                  to=""
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={handleClose}
                >
                  Blog
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={handleClose}
                >
                  Contact
                </NavLink>
              </li>
              <li className="nav-item career-btn">
                <NavLink
                  to=""
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={handleClose}
                >
                  <span>Career</span>
                </NavLink>  
              </li>
            </ul>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Header;
